import React, { Component } from "react";
import { connect } from "react-redux";
import { PageHeader, Card, Table, Input, InputNumber, Alert, message, Spin, Tooltip, Select, Row, Col, Upload, Popconfirm, Tag, Switch, Radio, Space } from "antd";
import { QuestionCircleOutlined, PictureOutlined, EditOutlined, DeleteOutlined, PlusOutlined, MailOutlined } from "@ant-design/icons";
import { ButtonItem, SelectEmpleadosItem } from "../../../../Components/Items";
import SelectUsuarioItem from "../../../../Components/SelectUsuarioItem";
import { cmmsPost, normFile, fileListAPayload } from "../cmmsComun";
import ModalClienteConfigCMMS from "./ModalClienteConfigCMMS";
import AvisosProgramadosCMMS from "./AvisosProgramadosCMMS";

const componer = (serie, numero, longitud) => `${serie || ""}${String(numero || 1).padStart(longitud || 5, "0")}`;

// Configuracion del modulo CMMS: series y numeracion de folios, y las listas de
// opciones del activo (categorias, pertenencias, jerarquias).
// (Los membretes por cliente y de la empresa se agregan en la etapa de PDFs.)
class ConfiguracionCMMS extends Component {
    state = {
        loading: true,
        guardando: false,
        series: [],
        proveedorServicioNombre: "",
        categorias: [],
        pertenencias: [],
        jerarquias: [],
        tiposSolicitud: [],
        tiposContrato: [],
        motivosNoRealizado: [],
        categoriasViatico: [],
        ingenieros: [],
        membreteDefault: [],
        logoEtiqueta: [],
        marcaAgua: [],
        margenes: {},
        textoPie: "",
        lugarEmision: "",
        codigoReporteVisita: "",
        correosTicket: [],
        avisarSolicitante: true,
        avisos: [],
        seccionesAviso: [],
        concluirApp: "ingeniero",
        clientesConfig: [],
        modalCliente: false,
        clienteEditar: null,
    };

    componentDidMount() {
        this.consultar();
        this.consultarClientesConfig();
    }

    consultar = async () => {
        this.setState({ loading: true });
        try {
            const res = await cmmsPost(this.props, "datosConfiguracionCMMS");
            if (res.data.success === 2) {
                this.setState({
                    series: res.data.configuracion.series.map((s) => ({ ...s, siguienteNumeroOriginal: s.siguienteNumero })),
                    proveedorServicioNombre: res.data.configuracion.proveedorServicioNombre,
                    categorias: res.data.configuracion.categorias || [],
                    pertenencias: res.data.configuracion.pertenencias || [],
                    jerarquias: res.data.configuracion.jerarquias || [],
                    tiposSolicitud: res.data.configuracion.tiposSolicitud || [],
                    tiposContrato: res.data.configuracion.tiposContrato || [],
                    motivosNoRealizado: res.data.configuracion.motivosNoRealizado || [],
                    categoriasViatico: res.data.configuracion.categoriasViatico || [],
                    ingenieros: (res.data.configuracion.ingenieros || []).map((i, n) => ({ ...i, key: `i${n}` })),
                    membreteDefault: res.data.configuracion.membreteDefault || [],
                    logoEtiqueta: res.data.configuracion.logoEtiqueta || [],
                    marcaAgua: res.data.configuracion.marcaAgua || [],
                    margenes: res.data.configuracion.margenesMembrete || {},
                    textoPie: res.data.configuracion.textoPie || "",
                    lugarEmision: res.data.configuracion.lugarEmision || "",
                    codigoReporteVisita: res.data.configuracion.codigoReporteVisita || "",
                    correosTicket: res.data.configuracion.avisosTicket?.correos || [],
                    avisarSolicitante: res.data.configuracion.avisosTicket?.avisarSolicitante !== false,
                    avisos: res.data.configuracion.avisos || [],
                    seccionesAviso: res.data.configuracion.seccionesAviso || [],
                    concluirApp: res.data.configuracion.app?.concluir || "ingeniero",
                });
            }
        } catch (error) {
            console.log(error);
            message.error("Error al consultar la configuración");
        } finally {
            this.setState({ loading: false });
        }
    };

    consultarClientesConfig = async () => {
        try {
            const res = await cmmsPost(this.props, "selectClientesConfigCMMS");
            if (res.data.success === 2) this.setState({ clientesConfig: res.data.configs });
        } catch (error) {
            console.log(error);
        }
    };

    eliminarClienteConfig = async (clienteId) => {
        const res = await cmmsPost(this.props, "eliminarClienteConfigCMMS", { clienteId });
        if (res.data.success === 2) this.consultarClientesConfig();
        else message.error(res.data.message || "No se pudo quitar");
    };

    // Lista de correos (tags): sin repetir, solo validos y maximo 10.
    cambiarCorreos = (campo, valores) => {
        const correos = valores.map((v) => String(v).trim().toLowerCase()).filter(Boolean);
        const invalidos = correos.filter((c) => !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(c));
        if (invalidos.length) message.warning(`No es un correo válido: ${invalidos.join(", ")}`);
        this.setState({ [campo]: [...new Set(correos.filter((c) => !invalidos.includes(c)))].slice(0, 10) });
    };

    // Los avisos programados se guardan aparte (al aceptar su editor): solo se recargan ellos, para
    // no perder lo que no se ha guardado en el resto de la pantalla.
    recargarAvisos = async () => {
        try {
            const res = await cmmsPost(this.props, "datosConfiguracionCMMS");
            if (res.data.success === 2) this.setState({ avisos: res.data.configuracion.avisos || [] });
        } catch (error) {
            console.log(error);
        }
    };

    cambiarIngeniero = (key, cambios) => this.setState((s) => ({ ingenieros: s.ingenieros.map((i) => (i.key === key ? { ...i, ...cambios } : i)) }));

    cambiar = (tipo, campo, valor) =>
        this.setState((s) => ({ series: s.series.map((x) => (x.tipo === tipo ? { ...x, [campo]: valor } : x)) }));

    guardar = async () => {
        this.setState({ guardando: true });
        try {
            const res = await cmmsPost(this.props, "editarConfiguracionCMMS", {
                proveedorServicioNombre: this.state.proveedorServicioNombre,
                categorias: this.state.categorias,
                pertenencias: this.state.pertenencias,
                jerarquias: this.state.jerarquias,
                tiposSolicitud: this.state.tiposSolicitud,
                tiposContrato: this.state.tiposContrato,
                motivosNoRealizado: this.state.motivosNoRealizado,
                categoriasViatico: this.state.categoriasViatico,
                ingenieros: this.state.ingenieros.filter((i) => i.empleadoId || i.usuarioId).map(({ empleadoId, usuarioId }) => ({ empleadoId, usuarioId })),
                membreteDefault: (await fileListAPayload(this.state.membreteDefault))[0] || null,
                logoEtiqueta: (await fileListAPayload(this.state.logoEtiqueta))[0] || null,
                marcaAgua: (await fileListAPayload(this.state.marcaAgua))[0] || null,
                margenesMembrete: this.state.margenes,
                textoPie: this.state.textoPie,
                lugarEmision: this.state.lugarEmision,
                codigoReporteVisita: this.state.codigoReporteVisita,
                avisosTicket: { correos: this.state.correosTicket, avisarSolicitante: this.state.avisarSolicitante },
                app: { concluir: this.state.concluirApp },
                series: this.state.series.map((s) => ({
                    tipo: s.tipo,
                    serie: s.serie,
                    longitud: s.longitud,
                    // Solo se manda si se cambio: evita "subir" un contador que otro usuario movio mientras tanto.
                    siguienteNumero: s.siguienteNumero !== s.siguienteNumeroOriginal ? s.siguienteNumero : null,
                })),
            });
            if (res.data.success === 2) {
                message.success("Configuración guardada");
                this.consultar();
            } else {
                message.error(res.data.message || "No se pudo guardar la configuración");
            }
        } catch (error) {
            console.log(error);
            message.error("No se pudo guardar la configuración");
        } finally {
            this.setState({ guardando: false });
        }
    };

    render() {
        const columns = [
            { title: "Documento", dataIndex: "etiqueta", key: "etiqueta", width: "20%" },
            {
                title: "Serie",
                dataIndex: "serie",
                key: "serie",
                width: "18%",
                render: (value, record) => (
                    <Input value={value} maxLength={10} onChange={(e) => this.cambiar(record.tipo, "serie", e.target.value.toUpperCase())} />
                ),
            },
            {
                title: (
                    <Tooltip title="Cantidad de dígitos del número (se rellena con ceros a la izquierda).">
                        Dígitos <QuestionCircleOutlined />
                    </Tooltip>
                ),
                dataIndex: "longitud",
                key: "longitud",
                width: "14%",
                render: (value, record) => <InputNumber min={1} max={12} value={value} onChange={(v) => this.cambiar(record.tipo, "longitud", v)} />,
            },
            {
                title: (
                    <Tooltip title="Número que tomará el siguiente documento. Sólo puede subir: úselo para continuar la numeración de su sistema anterior.">
                        Siguiente número <QuestionCircleOutlined />
                    </Tooltip>
                ),
                dataIndex: "siguienteNumero",
                key: "siguienteNumero",
                width: "18%",
                render: (value, record) => (
                    <InputNumber min={record.ultimoNumero + 1} value={value} onChange={(v) => this.cambiar(record.tipo, "siguienteNumero", v)} style={{ width: "100%" }} />
                ),
            },
            {
                title: "Siguiente folio",
                key: "ejemplo",
                width: "18%",
                render: (_, record) => <b>{componer(record.serie, record.siguienteNumero, record.longitud)}</b>,
            },
            { title: "Último emitido", dataIndex: "ultimoNumero", key: "ultimoNumero", width: "12%", render: (v) => v || "—" },
        ];

        return (
            <>
                <PageHeader
                    title="Configuración"
                    subTitle="Mantenimiento"
                    style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
                    extra={
                        <ButtonItem type="primary" loading={this.state.guardando} onClick={this.guardar}>
                            Guardar
                        </ButtonItem>
                    }
                />
                <Spin spinning={this.state.loading}>
                    <Card title="Series y folios" style={{ marginBottom: 10 }}>
                        <Alert
                            type="info"
                            showIcon
                            style={{ marginBottom: 12 }}
                            message="Cada documento del módulo toma su folio de aquí (por ejemplo AST00001 para activos). Si cancela un documento su folio no se reutiliza."
                        />
                        <Table size="small" rowKey="tipo" pagination={false} dataSource={this.state.series} columns={columns} />
                    </Card>
                    <Card title="Listas de opciones" style={{ marginBottom: 10 }}>
                        <Alert
                            type="info"
                            showIcon
                            style={{ marginBottom: 12 }}
                            message="Opciones que aparecen al dar de alta un activo. Escriba una opción y presione Enter para agregarla; quítela con la x. Renombrar o quitar una opción no cambia los activos que ya la tienen."
                        />
                        <Row gutter={16}>
                            {[
                                ["categorias", "Categorías", "Clasificación general del equipo (Equipo médico, Mobiliario...)."],
                                ["pertenencias", "Pertenencias", "De quién es el equipo (Propiedad del cliente, Arrendamiento, Comodato...)."],
                                ["jerarquias", "Jerarquías", "Qué tan crítico es el equipo. 'Por definir' es la que se asigna si no se elige otra."],
                                ["tiposSolicitud", "Tipos de solicitud", "Opciones del campo Tipo de solicitud de los tickets (Falla, Instalación...). También las ve el hospital al reportar desde el QR."],
                                ["tiposContrato", "Tipos de contrato", "Opciones del campo Tipo de contrato (Mantenimiento preventivo, Licitación pública...)."],
                                ["motivosNoRealizado", "Motivos de no realizado", "Por qué no se hizo un servicio calendarizado (equipo no disponible, en uso por paciente...). Salen en el progreso del contrato."],
                                ["categoriasViatico", "Categorías de viáticos", "Opciones de los viáticos que se capturan en el servicio (Hospedaje, Alimentos, Casetas...). Se suman en el reporte de viáticos."],
                            ].map(([clave, etiqueta, ayuda]) => (
                                <Col xs={24} md={12} xl={8} key={clave} style={{ marginBottom: 12 }}>
                                    <div style={{ marginBottom: 4, fontWeight: 500 }}>
                                        {etiqueta}{" "}
                                        <Tooltip title={ayuda}>
                                            <QuestionCircleOutlined />
                                        </Tooltip>
                                    </div>
                                    <Select
                                        mode="tags"
                                        style={{ width: "100%" }}
                                        value={this.state[clave]}
                                        onChange={(valores) => this.setState({ [clave]: valores })}
                                        placeholder="Escriba y presione Enter"
                                        open={false}
                                        tokenSeparators={[","]}
                                    />
                                </Col>
                            ))}
                        </Row>
                    </Card>
                    <Card
                        title="Ingenieros"
                        style={{ marginBottom: 10 }}
                        extra={
                            <ButtonItem type="default" icon={<PlusOutlined />} onClick={() => this.setState((s) => ({ ingenieros: [...s.ingenieros, { key: `n${Date.now()}`, empleadoId: null, usuarioId: null }] }))}>
                                Agregar ingeniero
                            </ButtonItem>
                        }
                    >
                        <Alert
                            type="info"
                            showIcon
                            style={{ marginBottom: 12 }}
                            message="Ligue a cada ingeniero (empleado) con el usuario con que entra al ERP. Con eso, en Servicios › Mis servicios cada ingeniero ve directamente cómo va con lo suyo, sus servicios nuevos ya traen su nombre (y después lo usará la app). Además, cada usuario puede fijar un ingeniero con la chincheta del filtro de Ingeniero para ver siempre sólo lo suyo en todo el CMMS."
                        />
                        <Table
                            size="small"
                            rowKey="key"
                            pagination={false}
                            dataSource={this.state.ingenieros}
                            locale={{ emptyText: "Ningún ingeniero ligado todavía" }}
                            columns={[
                                {
                                    title: "Ingeniero (empleado)",
                                    dataIndex: "empleadoId",
                                    render: (v, r) => (
                                        <SelectEmpleadosItem
                                            empresaId={this.props.empresaId}
                                            headersToken={this.props.headersToken}
                                            width="100%"
                                            value={v || undefined}
                                            onChange={(empleadoId) => this.cambiarIngeniero(r.key, { empleadoId: empleadoId || null })}
                                        />
                                    ),
                                },
                                {
                                    title: "Usuario del ERP",
                                    dataIndex: "usuarioId",
                                    render: (v, r) => (
                                        <SelectUsuarioItem
                                            empresaId={this.props.empresaId}
                                            headersToken={this.props.headersToken}
                                            style={{ width: "100%" }}
                                            placeholder="Usuario"
                                            value={v || undefined}
                                            onChange={(usuarioId) => this.cambiarIngeniero(r.key, { usuarioId: usuarioId || null })}
                                        />
                                    ),
                                },
                                {
                                    title: "",
                                    width: 50,
                                    render: (r) => <ButtonItem type="default" size="small" rojo icon={<DeleteOutlined />} onClick={() => this.setState((s) => ({ ingenieros: s.ingenieros.filter((x) => x.key !== r.key) }))} />,
                                },
                            ]}
                        />
                    </Card>
                    <Card title="Impresión de la empresa" style={{ marginBottom: 10 }}>
                        <Row gutter={20}>
                            <Col xs={24} lg={8}>
                                <div style={{ marginBottom: 4, fontWeight: 500 }}>
                                    Hoja membretada{" "}
                                    <Tooltip title="Imagen de hoja completa tamaño carta (PNG o JPG) que va de fondo en la Orden de Servicio. Un cliente puede tener la suya (abajo). Sin membrete, la orden lleva el logo y los datos de la empresa.">
                                        <QuestionCircleOutlined />
                                    </Tooltip>
                                </div>
                                <Upload
                                    listType="picture-card"
                                    maxCount={1}
                                    accept="image/png,image/jpeg"
                                    fileList={this.state.membreteDefault}
                                    beforeUpload={() => false}
                                    onChange={(e) => this.setState({ membreteDefault: normFile(e) })}
                                >
                                    <div>
                                        <PictureOutlined />
                                        <div style={{ marginTop: 6, fontSize: 12 }}>Membrete</div>
                                    </div>
                                </Upload>
                                <div style={{ fontSize: 12, margin: "8px 0 4px" }}>Márgenes del contenido (puntos: arriba · abajo · izquierda · derecha)</div>
                                <div style={{ display: "flex", gap: 6 }}>
                                    {[
                                        ["arriba", 110],
                                        ["abajo", 90],
                                        ["izquierda", 40],
                                        ["derecha", 40],
                                    ].map(([k, d]) => (
                                        <InputNumber
                                            key={k}
                                            min={0}
                                            max={400}
                                            placeholder={k}
                                            value={this.state.margenes?.[k] ?? d}
                                            onChange={(v) => this.setState((s) => ({ margenes: { ...s.margenes, [k]: v } }))}
                                            style={{ width: 70 }}
                                        />
                                    ))}
                                </div>
                            </Col>
                            <Col xs={12} lg={4}>
                                <div style={{ marginBottom: 4, fontWeight: 500 }}>
                                    Logo de la etiqueta{" "}
                                    <Tooltip title="Logo que sale en la etiqueta QR. Si no hay, se usa el logo de la empresa. Un cliente puede tener el suyo (abajo).">
                                        <QuestionCircleOutlined />
                                    </Tooltip>
                                </div>
                                <Upload
                                    listType="picture-card"
                                    maxCount={1}
                                    accept="image/png,image/jpeg"
                                    fileList={this.state.logoEtiqueta}
                                    beforeUpload={() => false}
                                    onChange={(e) => this.setState({ logoEtiqueta: normFile(e) })}
                                >
                                    <div>
                                        <PictureOutlined />
                                        <div style={{ marginTop: 6, fontSize: 12 }}>Logo</div>
                                    </div>
                                </Upload>
                            </Col>
                            <Col xs={12} lg={4}>
                                <div style={{ marginBottom: 4, fontWeight: 500 }}>
                                    Marca de agua{" "}
                                    <Tooltip title="Logo (PNG o JPG) que se imprime muy tenue al centro de cada hoja de la Orden de Servicio, los certificados y el reporte de visita. Un cliente puede tener la suya (abajo).">
                                        <QuestionCircleOutlined />
                                    </Tooltip>
                                </div>
                                <Upload
                                    listType="picture-card"
                                    maxCount={1}
                                    accept="image/png,image/jpeg"
                                    fileList={this.state.marcaAgua}
                                    beforeUpload={() => false}
                                    onChange={(e) => this.setState({ marcaAgua: normFile(e) })}
                                >
                                    <div>
                                        <PictureOutlined />
                                        <div style={{ marginTop: 6, fontSize: 12 }}>Marca de agua</div>
                                    </div>
                                </Upload>
                            </Col>
                            <Col xs={24} lg={8}>
                                <div style={{ marginBottom: 4 }}>
                                    Proveedor de servicio{" "}
                                    <Tooltip title="Nombre que se imprime como 'Proveedor de Servicio' en etiquetas y órdenes de servicio. Si se deja vacío se usa la razón social de la empresa.">
                                        <QuestionCircleOutlined />
                                    </Tooltip>
                                </div>
                                <Input placeholder="Razón social de la empresa" value={this.state.proveedorServicioNombre} onChange={(e) => this.setState({ proveedorServicioNombre: e.target.value })} />
                                <div style={{ margin: "10px 0 4px" }}>
                                    Pie de página de la Orden de Servicio{" "}
                                    <Tooltip title="Texto al pie cuando la orden NO lleva hoja membretada (ej. dirección y teléfonos).">
                                        <QuestionCircleOutlined />
                                    </Tooltip>
                                </div>
                                <Input.TextArea rows={2} maxLength={500} value={this.state.textoPie} onChange={(e) => this.setState({ textoPie: e.target.value })} />
                                <Row gutter={8} style={{ marginTop: 10 }}>
                                    <Col xs={24} md={15}>
                                        <div style={{ marginBottom: 4 }}>
                                            Lugar de emisión{" "}
                                            <Tooltip title='Encabeza la carta del reporte de visita: "San Luis Potosí, S.L.P. a viernes 9 de octubre del 2026".'>
                                                <QuestionCircleOutlined />
                                            </Tooltip>
                                        </div>
                                        <Input placeholder="Ej. San Luis Potosí, S.L.P." maxLength={120} value={this.state.lugarEmision} onChange={(e) => this.setState({ lugarEmision: e.target.value })} />
                                    </Col>
                                    <Col xs={24} md={9}>
                                        <div style={{ marginBottom: 4 }}>
                                            Código del formato{" "}
                                            <Tooltip title="Clave del formato que sale en el Anexo A del reporte de visita (ej. F-SE-01).">
                                                <QuestionCircleOutlined />
                                            </Tooltip>
                                        </div>
                                        <Input placeholder="Ej. F-SE-01" maxLength={30} value={this.state.codigoReporteVisita} onChange={(e) => this.setState({ codigoReporteVisita: e.target.value })} />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Card>
                    <Card
                        title="Impresión por cliente"
                        extra={
                            <ButtonItem type="primary" onClick={() => this.setState({ modalCliente: true, clienteEditar: null })}>
                                Agregar cliente
                            </ButtonItem>
                        }
                    >
                        <div style={{ fontSize: 12, color: "#7a8794", marginBottom: 8 }}>
                            Clientes con hoja membretada, marca de agua, logo de etiqueta o datos propios (ej. ISSEMYM con el membrete de MEDIZIN XXI). Lo que un cliente no tenga se toma de la empresa.
                        </div>
                        <Table
                            size="small"
                            rowKey="clienteId"
                            pagination={false}
                            dataSource={this.state.clientesConfig}
                            locale={{ emptyText: "Ningún cliente tiene impresión propia" }}
                            columns={[
                                { title: "Cliente", dataIndex: "clienteNombre" },
                                { title: "Membrete", dataIndex: "tieneMembrete", width: 110, render: (v) => (v ? <Tag color="green">Sí</Tag> : <Tag>No</Tag>) },
                                { title: "Logo etiqueta", dataIndex: "tieneLogo", width: 120, render: (v) => (v ? <Tag color="green">Sí</Tag> : <Tag>No</Tag>) },
                                { title: "Marca de agua", dataIndex: "tieneMarcaAgua", width: 120, render: (v) => (v ? <Tag color="green">Sí</Tag> : <Tag>No</Tag>) },
                                { title: "Firmas", dataIndex: "lineasFirma", width: 80 },
                                {
                                    title: "",
                                    width: 100,
                                    render: (r) => (
                                        <span style={{ display: "flex", gap: 4 }}>
                                            <ButtonItem type="default" size="small" cyan icon={<EditOutlined />} onClick={() => this.setState({ modalCliente: true, clienteEditar: r.clienteId })} />
                                            <Popconfirm title="¿Quitar la impresión propia de este cliente?" onConfirm={() => this.eliminarClienteConfig(r.clienteId)} okText="Sí" cancelText="No">
                                                <ButtonItem type="default" size="small" rojo icon={<DeleteOutlined />} />
                                            </Popconfirm>
                                        </span>
                                    ),
                                },
                            ]}
                        />
                    </Card>
                    <Card title="Avisos de tickets" style={{ marginTop: 10 }}>
                        <Row gutter={20}>
                            <Col xs={24} lg={14}>
                                <div style={{ marginBottom: 4, fontWeight: 500 }}>
                                    <MailOutlined /> Avisar de cada ticket nuevo a{" "}
                                    <Tooltip title="Cada vez que se levanta un ticket (desde el ERP o desde el QR del equipo) se manda un correo con sus datos a estas direcciones. Escriba un correo y presione Enter; hasta 10.">
                                        <QuestionCircleOutlined />
                                    </Tooltip>
                                </div>
                                <Select
                                    mode="tags"
                                    style={{ width: "100%" }}
                                    value={this.state.correosTicket}
                                    onChange={(valores) => this.cambiarCorreos("correosTicket", valores)}
                                    placeholder="coordinacion@empresa.com"
                                    open={false}
                                    tokenSeparators={[",", ";", " "]}
                                />
                                <div style={{ fontSize: 12, color: "#7a8794", marginTop: 4 }}>Sin correos no se avisa a nadie (sigue llegando la notificación del ERP).</div>
                            </Col>
                            <Col xs={24} lg={10}>
                                <div style={{ marginBottom: 4, fontWeight: 500 }}>Avisar a quien levantó el ticket</div>
                                <div className="cmms-switch-linea">
                                    <Switch checked={this.state.avisarSolicitante} onChange={(avisarSolicitante) => this.setState({ avisarSolicitante })} />
                                    {this.state.avisarSolicitante ? "Sí, de cada avance de su ticket" : "No"}
                                </div>
                                <div style={{ fontSize: 12, color: "#7a8794", marginTop: 4 }}>
                                    Si dejó su correo, recibe un aviso al levantarlo y cada vez que cambia: asignado, en proceso (con su Orden de Servicio), en espera, finalizado, cerrado o cancelado.
                                </div>
                            </Col>
                        </Row>
                    </Card>
                    <Card title="App móvil" style={{ marginTop: 10 }}>
                        <div style={{ marginBottom: 6, fontWeight: 500 }}>¿Quién concluye la Orden de Servicio hecha en la app?</div>
                        <Radio.Group value={this.state.concluirApp} onChange={(e) => this.setState({ concluirApp: e.target.value })}>
                            <Space direction="vertical">
                                <Radio value="ingeniero">
                                    El ingeniero, en sitio
                                    <div className="cmms-ayuda" style={{ margin: 0 }}>
                                        La concluye desde la app con las firmas. Las refacciones que capture ahí no se descuentan del almacén.
                                    </div>
                                </Radio>
                                <Radio value="oficina">
                                    La oficina, en el web
                                    <div className="cmms-ayuda" style={{ margin: 0 }}>
                                        En la app queda “Terminada en sitio”; la oficina la revisa, ajusta refacciones y almacén, y la concluye aquí.
                                    </div>
                                </Radio>
                            </Space>
                        </Radio.Group>
                    </Card>
                    <AvisosProgramadosCMMS
                        empresaId={this.props.empresaId}
                        headersToken={this.props.headersToken}
                        avisos={this.state.avisos}
                        secciones={this.state.seccionesAviso}
                        onCambio={this.recargarAvisos}
                    />
                    <ModalClienteConfigCMMS
                        visible={this.state.modalCliente}
                        clienteId={this.state.clienteEditar}
                        onClose={(guardado) => this.setState({ modalCliente: false }, () => guardado && this.consultarClientesConfig())}
                    />
                </Spin>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ConfiguracionCMMS);
